export default __webpack_public_path__ + "media/images/theme/wordmark_dark-c9b58c57522c75ed581b65b2c8777c82.png";